export default __webpack_public_path__ + "static/media/envelope-outlined.c7e043eb.svg";